/*
  Sticky productbalk bij kleurproducten - 05-10-2026

  Besluit Cedric: in de balk geen kleurrondjes, en de klant kiest eerst
  bewust een kleur. Zolang dat niet gebeurd is, toont de knop in de balk
  "Kies een kleur" en scrolt hij naar de swatches bovenaan in plaats van iets
  toe te voegen. Na een keuze wordt het weer de gewone koopknop en staat de
  gekozen kleur onder de prijs.

  Markup en vlag: snippets/product-bar.liquid (class product-bar--kleurkeuze,
  zolang er niet gekozen is ook product-bar--kies). Stijl: c4s-swatches.css.

  "Gekozen" = een klik op een swatch in de kiezer van de pagina (ook op de al
  geselecteerde kleur - daarom click en niet alleen change; een klik op een
  radio die al aanstaat geeft geen change). De voorselectie bij het laden
  telt niet, ook niet via ?variant= in de URL: elke productkaart linkt met
  ?variant=, dus dat zegt niets over een keuze.

  De knop in de balk post het formulier op de pagina (extenders-product-bar.js).
  Dit script onderschept de klik in de capture-fase op document, dus vóór die
  handler, en alleen zolang er niet gekozen is.
*/
(function () {
  var balk = document.querySelector('product-bar.product-bar--kleurkeuze');
  if (!balk) return;

  function kiezer() {
    return document.querySelector('.main-product .variant-switcher__option-holder .c4s-swatch-gekozen')
      || document.querySelector('.variant-switcher__option-holder .c4s-swatch-gekozen');
  }

  function zetKleur(naam) {
    var n = balk.querySelector('[data-c4s-balk-kleur]');
    if (n && naam) n.textContent = naam;
  }

  document.addEventListener('click', function (e) {
    var i = e.target && e.target.closest && e.target.closest('.c4s-swatch input[type="radio"]');
    if (!i || balk.contains(i)) return;
    if (i.closest('quick-add-modal, .quick-add-modal')) return;
    balk.classList.remove('product-bar--kies');
    zetKleur(i.value);
  });

  document.addEventListener('change', function (e) {
    var i = e.target;
    if (i && i.matches && i.matches('.c4s-swatch input[type="radio"]') && !balk.classList.contains('product-bar--kies')) {
      zetKleur(i.value);
    }
  });

  document.addEventListener(
    'click',
    function (e) {
      if (!balk.classList.contains('product-bar--kies')) return;
      var knop = e.target && e.target.closest && e.target.closest('button[type="submit"]');
      if (!knop || !balk.contains(knop)) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      var k = kiezer();
      if (!k) return;
      var blok = k.closest('.variant-switcher__option-holder') || k;
      blok.scrollIntoView({ behavior: 'smooth', block: 'center' });
      blok.classList.remove('c4s-swatch-wijs');
      void blok.offsetWidth;
      blok.classList.add('c4s-swatch-wijs');
    },
    true
  );
})();
